export interface FilterOption {
  value: string;
  label: string;
}

export const clientStatusOptions: FilterOption[] = [
  { value: 'all', label: 'Todos los estatus' },
  { value: 'Activo', label: 'Activo' },
  { value: 'Suspendido', label: 'Suspendido' },
];

export const clientTypeOptions: FilterOption[] = [
  { value: 'all', label: 'Todos los tipos' },
  { value: 'Empresa', label: 'Empresa' },
  { value: 'Persona Física', label: 'Persona Física' },
];
